import { styled } from '@mui/material';
import Icon from 'core/svg-sprites/ui/Icon';

export const WrapperStyled = styled('div')`
  display: inline-flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.primary};
  background-color: ${({ theme }) => theme.palette.error.light + '30'};
`;

export const IconStyled = styled(Icon)`
  margin-right: 4px;
  fill: ${({ theme }) => theme.palette.error.main};
  transform: scaleY(-1);
`;
